import { Component, AfterViewInit, OnInit, HostListener, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { MainService } from '../../../service/main.service';
import { AuthenticationService } from '../../../../authentication.service';
import { MainService as portal_mainService } from '../../../../portal/service/main.service';
import { Router } from '@angular/router';
import { session } from '../../../../../environments/environment.session'
import { Utf8EncodingService } from 'src/app/md/service/utf8-encoding.service';
import html2canvas from 'html2canvas';
import { NotificationSocketService } from '../../../../service/notification-socket.service';
import Swal from 'sweetalert2';
import { FirebaseMessagingService } from '../../../../firebase-messaging.service';

@Component({
  selector: '[app-header]',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {

  showUserMenu = false;
  showNotificationMenu = false;
  notificationsList: any[] = [];
  unreadNotifications: number = 0;

  // Pagination state
  notifLimit: number = 10;
  notifOffset: number = 0;
  hasMoreNotifications: boolean = false;
  isLoadingNotifications: boolean = false;

  constructor(private cd: ChangeDetectorRef, public auth: AuthenticationService, public router: Router, public portal_main: portal_mainService,
    public mainService: MainService, private utf8EncodingService: Utf8EncodingService, private notificationSocket: NotificationSocketService, private fcm: FirebaseMessagingService, private http: HttpClient) { }

  erpUser: any = {};
  roles: any[] = ['user', 'admin', 'super-admin']
  async ngOnInit() {
    this.cd.detectChanges();
    this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));
    await this.portal_main.getUserImage(this.erpUser['user_id']);
    // await this.portal_main.getAccImage(this.erpUser['b_acct_id']);
    await this.portal_main.getAccountInfo(this.erpUser['b_acct_id']);
    await this.portal_main.getHeaderInfo(this.erpUser['b_acct_id'], false);
    // await this.changeLanguage();
    this.mainService.accInfo = this.portal_main.accInfo;
    this.erpUser = JSON.parse(atob(session?.erpUser))
    this.mainService.data$.subscribe(data => {
      this.erpUser = data;
    });

    // Initialize Real-time Notification Socket
    if (this.erpUser && this.erpUser.user_id) {
      this.notificationSocket.connectAndRegister(this.erpUser.user_id, this.erpUser.b_acct_id);
      this.fcm.listen();
      this.fetchUnreadNotifications();
    }

    // Subscribe to incoming notifications
    this.notificationSocket.notifications$.subscribe((payload: any) => {
      // FCM broadcasts to the service worker which awakens ALL active tabs. 
      // Ensure we only process notifications meant for the currently logged-in user of THIS tab.
      if (payload.surveyorId && String(payload.surveyorId) !== String(this.erpUser.user_id)) {
        return; // Ignore notifications meant for another user sharing the same browser
      }
      if (!this.showNotificationMenu) {
        this.unreadNotifications++;
      }
      this.notificationsList.unshift({
        title: payload.title || 'New Notification',
        body: payload.body || '',
        time: new Date(),
        type: payload.type || 'info'
      });

      // Keep only latest 50 notifications
      if (this.notificationsList.length > 50) {
        this.notificationsList.pop();
      }

      // Show toast ONLY for real-time notifications
      if (!payload.isCatchup) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'info',
          title: payload.title || 'New Notification',
          text: payload.body || '',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true
        });
      }

      this.cd.detectChanges();
    });
  }


  fetchUnreadNotifications(loadMore = false) {
    if (this.isLoadingNotifications) return;
    this.isLoadingNotifications = true;

    if (!loadMore) {
      this.notifOffset = 0;
      this.notificationsList = [];
    }

    const body = {
      b_acct_id: this.erpUser.b_acct_id,
      user_id: this.erpUser.user_id,
      limit: this.notifLimit,
      offset: this.notifOffset
    };

    this.http.post<any>(`${this.auth.httpUrl}/acms/notifications/getNotifications`, body).subscribe({
      next: (res) => {
        this.isLoadingNotifications = false;
        if (!res.error && res.data) {
          const newNotifs = res.data.map((n: any) => {
            const parsedDate = new Date(n.created_at);
            return {
              title: n.title,
              body: n.body,
              time: !isNaN(parsedDate.getTime()) ? parsedDate : new Date(),
              type: n.notification_type || 'info',
              id: n.notification_uuid
            };
          });

          if (loadMore) {
            this.notificationsList = [...this.notificationsList, ...newNotifs];
          } else {
            this.notificationsList = newNotifs;
          }

          if (res.totalCount !== undefined) {
            // Only update the badge if the menu hasn't been opened yet
            if (!this.showNotificationMenu && this.unreadNotifications === 0) {
              this.unreadNotifications = res.totalCount;
            }
            this.hasMoreNotifications = this.notificationsList.length < res.totalCount;
          } else {
            // Fallback if totalCount is not present
            if (!this.showNotificationMenu && this.unreadNotifications === 0) {
              this.unreadNotifications = this.notificationsList.length;
            }
            this.hasMoreNotifications = newNotifs.length === this.notifLimit;
          }

          this.cd.detectChanges();
        }
      },
      error: (err) => {
        this.isLoadingNotifications = false;
        console.error("Error fetching notifications", err);
      }
    });
  }

  loadMoreNotifications() {
    if (this.hasMoreNotifications && !this.isLoadingNotifications) {
      this.notifOffset += this.notifLimit;
      this.fetchUnreadNotifications(true);
    }
  }

  markAllAsRead() {
    if (this.notificationsList.length === 0) return;
    const body = { b_acct_id: this.erpUser.b_acct_id, user_id: this.erpUser.user_id };
    this.http.post<any>(`${this.auth.httpUrl}/acms/notifications/markAllAsRead`, body).subscribe({
      next: (res) => {
        if (!res.error) {
          this.notificationsList = [];
          this.unreadNotifications = 0;
          this.hasMoreNotifications = false;
          this.showNotificationMenu = false;
          this.cd.detectChanges();
        }
      },
      error: (err) => console.error("Error marking all as read", err)
    });
  }

  handleNotificationClick(notif: any) {
    this.showNotificationMenu = false;
    // Assuming notifications are generally related to the dashboard/assignments
    const currentUrl = this.router.url;
    if (currentUrl === '/acms/acms-index') {
      // If already on the dashboard, force a reload to refresh data
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/acms/acms-index']);
      });
    } else {
      // Otherwise just navigate to the dashboard
      this.router.navigate(['/acms/acms-index']);
    }
  }

  changeLanguage() {
    this.mainService.language_cd = this.auth.language_cd
  }

  home() {
    this.router.navigate(['/index'])
  }

  ngAfterViewInit() {
  }


  toggleUserMenu() {
    this.showUserMenu = !this.showUserMenu;
    if (this.showUserMenu) this.showNotificationMenu = false;
  }

  toggleNotificationMenu() {
    this.showNotificationMenu = !this.showNotificationMenu;
    if (this.showNotificationMenu) {
      this.showUserMenu = false;

      if (this.unreadNotifications > 0) {
        this.unreadNotifications = 0;
        const body = { b_acct_id: this.erpUser.b_acct_id, user_id: this.erpUser.user_id };
        this.http.post<any>(`${this.auth.httpUrl}/acms/notifications/markAllAsRead`, body).subscribe({
          error: (err) => console.error("Error marking as read on open", err)
        });
      }
    }
  }

  @HostListener('document:click', ['$event'])
  onDocClick(e: MouseEvent) {
    const target = e.target as HTMLElement;
    if (!target.closest('.user-menu') && !target.closest('.avatar-btn')) {
      this.showUserMenu = false;
    }
    if (!target.closest('.notification-menu') && !target.closest('.notification-btn')) {
      this.showNotificationMenu = false;
    }
  }

  async logOut() {
    this.showUserMenu = false;
    this.notificationSocket.disconnect();
    try {
      await this.auth.logout();
    } catch (e) { }
    sessionStorage.removeItem("1001");
    sessionStorage.removeItem("1000");
    sessionStorage.removeItem("1005");
    session.erpUser = undefined
    await this.router.navigate(['/login']);
  }

  goToProfile() {
    this.router.navigate(['/acms/acms-profile'])
    this.toggleUserMenu()
  }


  exportAsImage() {
    const element: any = document.getElementById('download-area');

    html2canvas(element).then((canvas: any) => {
      const image = canvas.toDataURL('image/png');

      const link = document.createElement('a');
      link.href = image;
      link.download = 'component.png';
      link.click();
    });
  }
}